import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import Footer from '../common/Footer';
import Header from '../common/Header';

function Layout() {
  const user = useSelector((state) => state.user);
  const roleId = user?.role?.id;

  return (
    <>
      <Header />
      <div
        className={classNames('content content-fixed align-items-start pd-y-0  tx-roboto', {
          'content-auth-alt mg-t-20-f mg-lg-t-30-f': roleId,
          'mg-t-0 pd-0': !roleId,
        })}
      >
        <Outlet />
      </div>
      <Footer />
    </>
  );
}

export default Layout;
